import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { myFetch } from '@/commons/fetch';

// Types
interface FilesState {
  files: any[];
  isLoading: boolean;
  error: string | null;
  hasFetched: boolean;
}

const initialState: FilesState = {
  files: [],
  isLoading: false,
  error: null,
  hasFetched: false,
};

// Async Thunks
export const fetchFiles = createAsyncThunk(
  'files/fetchFiles',
  async (username: string, { rejectWithValue }) => {
    try {
      const response = await myFetch(`/${username}/files`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch files');
    }
  }
);

// Slice
const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearFiles: (state) => {
      state.files = [];
      state.error = null;
      state.hasFetched = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch Files
    builder
      .addCase(fetchFiles.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.files = action.payload;
        state.hasFetched = true;
      })
      .addCase(fetchFiles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.hasFetched = true;
      });
  },
});

export const { clearError, clearFiles } = filesSlice.actions;
export default filesSlice.reducer;
